import React from 'react';

function Error({ error }) {
    return error ? <p className="error"> {error} </p> : <></>;
}

export default Error;
